import { Component, Input, OnInit, inject } from '@angular/core';
import { AppService } from '../../../_services/app.service';

@Component({
  selector: 'manager-loader-wrapper-modal',
  templateUrl: './loader_wrapper_modal.component.html',
  standalone: false,
})
export class LoaderWrapperModalComponent implements OnInit {
  appS = inject(AppService);

  @Input() type: string;
  @Input() wrapper: string;
  //
  @Input() header: boolean;
  @Input() footer: boolean;

  ngOnInit() {}
}
